import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Locked = () => {
    const { t } = useTranslation('common');

    return (
        <div className="bg-neutral-0 flex h-full w-full items-center justify-center">
            <div className="justify-center text-center">
                <Lock className="text-muted-foreground mx-auto size-16" strokeWidth={1} />
                <h3 className="mt-2 text-base font-medium text-neutral-900">
                    {t('common:pages.accessRestricted.title')}
                </h3>
                <p className="text-muted-foreground mt-1 text-base font-medium">
                    {t('common:pages.accessRestricted.description')}
                </p>
            </div>
        </div>
    );
};

export default Locked;
